import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { LogApiService, UpdateStatusUnItemDTO } from 'features/log/api/log-api.services';
import { queryClient } from 'providers';

import { LogQueryKeys } from './query-keys';


const { updateUnloadingItemStatus } = LogApiService();

export const useUpdateStatusUnloadingItem = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: UpdateStatusUnItemDTO) => {
      return updateUnloadingItemStatus(payload);
    },
    {
      onError: (error) => {

        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data, variables) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: LogQueryKeys.lists(),
          }),
          queryClient.invalidateQueries({
           
            queryKey: LogQueryKeys.detail(variables.EntryId),
          }),
        ]);
        if(data.rs==1){            
          message.success(data.customMessage);
        }else{
            message.error('Something went wrong.');
        }
        
      },
    },
  );
};


